<template>
    <section class="header">
        <div class="header-image">
            <img :src="live.poster">
        </div>
    </section>
</template>

<script>
export default {
    name: "",
    props: {
        live: Object
    }
}
</script>

<style scoped>
.header-image img {
    width: 100%;
    height: 75%;
}
</style>
